let deferredPrompt;

function isAndroid() {
  return /Android/i.test(navigator.userAgent);
}

function isChromeOnAndroid() {
  return isAndroid() && /Chrome/i.test(navigator.userAgent) && !/SamsungBrowser|EdgA|OPR|Firefox/i.test(navigator.userAgent);
}

function isSamsungInternet() {
  return /SamsungBrowser/i.test(navigator.userAgent);
}

function updateInstallHints() {
  const browserHint = document.getElementById('pwa-browser-hint');
  const playProtectHint = document.getElementById('pwa-play-protect-hint');
  if (!browserHint || !playProtectHint) return;

  const showBrowserHint = isAndroid() && !isChromeOnAndroid();
  const showPlayProtectHint = isAndroid() && isChromeOnAndroid();

  browserHint.style.display = showBrowserHint ? 'block' : 'none';
  playProtectHint.style.display = showPlayProtectHint ? 'block' : 'none';

  if (showBrowserHint) {
    const browserName = isSamsungInternet() ? 'Samsung Internet' : 'este navegador';
    browserHint.textContent =
      `Para evitar avisos do Play Protect, abra controlbirds.com.br no Google Chrome. Instalar pelo ${browserName} pode exibir alertas de segurança.`;
  }
}

window.addEventListener('DOMContentLoaded', () => {
  const installContainer = document.getElementById('pwa-install-container');
  const installBtn = document.getElementById('btnInstallPWA');

  if (!installBtn || !installContainer) return;

  updateInstallHints();

  installBtn.addEventListener('click', async () => {
    if (!deferredPrompt) return;

    installContainer.style.display = 'none';
    deferredPrompt.prompt();

    const result = await deferredPrompt.userChoice;
    if (result.outcome === 'accepted') {
      console.log('Usuário aceitou instalar o app');
    } else {
      console.log('Usuário recusou instalar o app');
    }

    deferredPrompt = null;
  });

  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    deferredPrompt = e;

    updateInstallHints();
    installContainer.style.display = 'block';
  });
});
